<template>
	<div class="stripe-embedded">
		<div style="height:4px;">
			<v-progress-linear v-if="loading" indeterminate />
		</div>

		<div class="stripe-embedded__content" :class="computedClass">
			<div v-if="error" class="stripe-embedded__error">
				<slot name="error" v-bind="{ initSession }">
					<v-alert type="error" text outlined>
						<p>Could not init Stripe embedded checkout.</p>
						<v-btn @click="initSession">Try Again</v-btn>
					</v-alert>
				</slot>
			</div>

			<div v-else :id="id" />
		</div>
	</div>
</template>

<script>
export default {
    name: 'StripeCheckoutEmbedded',
    props: {
        sessionData: { type: Object },
        editMode: { type: Boolean, default: false },
    },
    data: () => ({
		id: `checkout_${Math.random().toString(36).substring(7)}`,
		checkout: null,
		loading: false,
		error: false,
    }),
	mounted () {
		this.initSession()
	},
	watch: {
		sessionData () {
			this.initSession()
		},
	},
	computed: {
		computedClass () {
			return [
				this.loading && 'content-loading',
			]
		},
	},
    methods: {
        async initSession () {
			if (!this.sessionData) { return }

			this.loading = true
			this.error = false
			try {
				this.checkout = await this.$stripe.initCheckout(this.sessionData, this.editMode)
				this.checkout?.mount(`#${this.id}`)
			} catch (e) {
				this.error = true
				this.showError('Could not init Stripe embedded checkout.<br>', e)
			} finally {
				this.loading = false
			}
        },
    },
}
</script>

<style lang="scss" scoped>
.stripe-embedded {
	.stripe-embedded__content {
		transition: opacity 0.2sec;
		opacity: 1;
	}

	.stripe-embedded__error {
		text-align: center;
	}

	.content-loading {
		opacity: 0;
	}
}
</style>
